import { MainContainerWrapper } from 'common/components/MainContainerWrapper/MainContainerWrapper';
import { FC } from 'react';
import { TaskResultsTable } from './components/TaskResultsTable';

export const SpokaneSync: FC = () => {
  return (
    <MainContainerWrapper title='Spokane Sync' maxWidth='1100px'>
      <TaskResultsTable />
    </MainContainerWrapper>
  );
};
